import { useState } from "react";
import BrandLogo from "@/components/BrandLogo";
import api from "@/lib/api";
import { toast } from "sonner";

const TYPES = [
  { value: "whole", label: "Whole Lechon", price: 450, note: "Serves 25-30" },
  { value: "half", label: "Half Lechon", price: 240, note: "Serves 12-15" },
  { value: "belly", label: "Lechon Belly", price: 95, note: "Serves 6-8" },
  { value: "by_pound", label: "Lechon by the Pound", price: 18, note: "Per lb" },
];

export default function Lechon() {
  const [form, setForm] = useState({ customer_name: "", customer_phone: "", customer_email: "", lechon_type: "whole", quantity: 1, pickup_date: "", pickup_time: "", notes: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/lechon", form); toast.success("Reservation submitted!"); }
    catch (_) { toast.error("Could not submit"); }
  };
  const selected = TYPES.find(t => t.value === form.lechon_type);
  return (
    <div className="chow-theme bg-[#050505] text-[#FAF9F6] min-h-screen" data-testid="lechon-page">
      <section className="border-b border-[#D4AF37]/30 py-14 text-center">
        <BrandLogo type="lechon" size="lg" showText={false} className="justify-center mb-2" />
        <span className="font-accent text-xs text-[#D4AF37]">RESERVE</span>
        <h1 className="font-heading text-5xl mt-2">Whole Lechon <span className="italic text-[#D4AF37]">on Demand</span></h1>
        <p className="text-[#FAF9F6]/60 max-w-xl mx-auto mt-2">For weddings, fiestas, birthdays, and holidays. Reserve 48 hours in advance.</p>
      </section>

      <div className="max-w-5xl mx-auto px-4 lg:px-8 py-12 grid lg:grid-cols-2 gap-10">
        <div>
          <h2 className="font-heading text-3xl text-[#D4AF37] mb-5">Choose your lechon</h2>
          <div className="space-y-3">
            {TYPES.map((t) => (
              <label key={t.value} className={`chow-card p-5 cursor-pointer flex items-center gap-4 ${form.lechon_type === t.value ? "border-[#D4AF37]" : ""}`}>
                <input type="radio" name="type" value={t.value} checked={form.lechon_type === t.value} onChange={(e) => setForm({...form, lechon_type: e.target.value})} data-testid={`lechon-type-${t.value}`} className="accent-[#D4AF37]"/>
                <div className="flex-1">
                  <div className="font-heading text-xl text-[#D4AF37]">{t.label}</div>
                  <div className="text-xs text-[#FAF9F6]/60">{t.note}</div>
                </div>
                <div className="font-heading text-lg">${t.price}</div>
              </label>
            ))}
          </div>
        </div>
        <form onSubmit={submit} className="chow-card p-7 space-y-3">
          <h2 className="font-heading text-2xl text-[#D4AF37] mb-2">Reservation details</h2>
          <input required placeholder="Full name" data-testid="lechon-name" className="w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.customer_name} onChange={(e) => setForm({...form, customer_name: e.target.value})}/>
          <input required placeholder="Phone" data-testid="lechon-phone" className="w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.customer_phone} onChange={(e) => setForm({...form, customer_phone: e.target.value})}/>
          <input type="email" placeholder="Email" data-testid="lechon-email" className="w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.customer_email} onChange={(e) => setForm({...form, customer_email: e.target.value})}/>
          <div className="grid grid-cols-2 gap-3">
            <input type="number" min="1" placeholder="Quantity" data-testid="lechon-qty" className="bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.quantity} onChange={(e) => setForm({...form, quantity: parseFloat(e.target.value)})}/>
            <input required type="date" data-testid="lechon-date" className="bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.pickup_date} onChange={(e) => setForm({...form, pickup_date: e.target.value})}/>
          </div>
          <input type="time" data-testid="lechon-time" className="w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.pickup_time} onChange={(e) => setForm({...form, pickup_time: e.target.value})}/>
          <textarea rows={3} placeholder="Notes (event, special requests)" data-testid="lechon-notes" className="w-full bg-[#0a0a0a] border border-[#D4AF37]/30 rounded px-4 py-3 text-[#FAF9F6]" value={form.notes} onChange={(e) => setForm({...form, notes: e.target.value})}/>
          <div className="flex items-center justify-between border-t border-[#D4AF37]/20 pt-4">
            <div className="text-[#FAF9F6]/60 text-sm">Estimated</div>
            <div className="font-heading text-2xl text-[#D4AF37]">${(selected.price * (form.quantity || 1)).toFixed(2)}</div>
          </div>
          <button type="submit" data-testid="lechon-submit" className="btn-chow w-full">Reserve Now</button>
        </form>
      </div>
    </div>
  );
}
